import { Pba } from '../pba';
import { MethodEvaluationComparabilitySearch } from '../method-evaluation-pba-comparability-search';
import { MethodEvaluation } from '../method-evaluation';

export class PbaMethodEvaluationResponse {
  pba: Pba;
  methodEvaluations: MethodEvaluation[];
  compSearch?: MethodEvaluationComparabilitySearch[];
  srcDiscussionCollapsed?: boolean;
  destDiscussionCollapsed?: boolean;
  hasDeletedPba?: boolean;
}
